/** OAuth tokens as the app stores them. */
export interface ITokenSet {
  accessToken: string;
  refreshToken: string | null;
  idToken: string | null;
  /** Absolute expiry of the access token, unix epoch in milliseconds. */
  expiresAt: number;
  /** Lifetime the authorization server granted, in seconds (`expires_in`). */
  expiresIn: number;
}

/** A token response without `expires_in` is treated as valid for an hour. */
export const DEFAULT_EXPIRES_IN_S = 3600;
